// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__18MwB","actionsCol":"EnrolledClinics_actionsCol__1PW8Q"};